<div style="text-align: right; margin-left: 10px; margin-top: 10px">
  <itb-spinner [spinnerType]="'m'" *ngIf="isActivityExportLoading"></itb-spinner>
  <itb-round-button [className]="'light'" [iconClassName]="'export-list'" [tooltipText]="'Export Activity List'"
                    (onClickHandler)="activityExport()" *ngIf="!isActivityExportLoading"></itb-round-button>
</div>
